module.exports = __webpack_public_path__ + "static/media/LogImg.b622cffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/LogImg.png
// module id = 87
// module chunks = 0